import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICurrency } from "../../../components/currency/Currencies";
import {
  last30DaysDateRange,
  todayDateRange,
} from "../../../utils/date_formatter";
import uniqueId from "../../../utils/generateId";

export interface IPaginationState {
  page: number;
  lastVisitedPage: any;
  filters?: Record<string, string | number | null | any>;
  storeData: Record<
    number | any,
    {
      data: any;
      filters: Record<string, string | number>;
      to_currency?: ICurrency;
    }
  >;
}

const initialState: IPaginationState = {
  page: 1,
  filters: {
    period: "today",
    start_date: todayDateRange()[0],
    end_date: todayDateRange()[1],
    branch: [],
  },
  storeData: {},
  lastVisitedPage: 1,
};

const PaginationSlice = createSlice({
  name: "DashboardPagination",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setData: (state, action: PayloadAction<{ data: any }>) => {
      const { data }: { data: any } = action.payload;
      state.storeData = {
        [state.lastVisitedPage]: {
          data,
          filters: state.filters || {},
        },
      };
    },
    setLastVisitedPage: (state, action: PayloadAction<any>) => {
      state.lastVisitedPage = action.payload;
    },
    clearData: (state) => {
      state.storeData = {};
    },
    clearPaginatedData: (state) => {
      state.storeData = {};
    },
    setFilters: (
      state,
      action: PayloadAction<Record<string, string | number>>,
    ) => {
      state.filters = action.payload;
    },
  },
});

export const {
  setData,
  setFilters,
  clearData,
  setLastVisitedPage,
  clearPaginatedData,
  setPage,
} = PaginationSlice.actions;

export const selectPagination = (state: {
  DashboardPagination: IPaginationState;
}) => state.DashboardPagination;

export default PaginationSlice.reducer;
